// extracted by mini-css-extract-plugin
export default {"committeeNewsCard":"committee-news-card_committeeNewsCard__Wiump","committeeContentNewsLinks":"committee-news-card_committeeContentNewsLinks__zumSN"};